export type PeriodoAquisitivo = 'ANC' | 'PAQ';

export interface OpcaoPeriodoAquisitivo {
    label: string;
    value: PeriodoAquisitivo;
}

export const OPCOES_PERIODO_AQUISITIVO: OpcaoPeriodoAquisitivo[] = [
    { label: 'Ano Civil', value: 'ANC' },
    { label: 'Período Aquisitivo', value: 'PAQ' }
];

export function obterDescricaoPeriodoAquisitivo(codigo: string | null | undefined): string {
    return OPCOES_PERIODO_AQUISITIVO.find(opcao => opcao.value === codigo)?.label ?? codigo ?? '';
}
